import { RouterProvider } from '@tanstack/react-router'
import AppTheme from '@/AppTheme'
import { App as UILibApp } from '@/components'
import router from './routing/router'

const App = () => (
  <AppTheme>
    <UILibApp>
      <RouterProvider router={router} />
    </UILibApp>
  </AppTheme>
)

export default App
